import React, { ReactNode } from 'react'
import { ViewNames } from '../../../../../navigation/reverseUrl'
import { DocumentsListItemDraggable } from '../DocumentListItemDraggable'
import { useDocumentDroppable } from '../useDocumentDroppable'
import { IDocumentModel } from '../../../../../interfaces/models/documents.interfaces'

interface FolderDropWrapperProps {
  document: IDocumentModel
  documentRoute: ViewNames
  openEditFolderModal: () => void
  openEditDocumentModal: () => void
  openRemoveConfirmationModal: () => void
  isListMode: boolean
}

export const FolderDropWrapper = ({
  document,
  documentRoute,
  openEditFolderModal,
  openEditDocumentModal,
  openRemoveConfirmationModal,
  isListMode,
}: FolderDropWrapperProps): ReactNode => {
  const { isOver, drop } = useDocumentDroppable(document._id)

  return (
    <div ref={drop} role="drop">
      <DocumentsListItemDraggable
        document={document}
        documentRoute={documentRoute}
        openEditDocumentModal={openEditDocumentModal}
        openEditFolderModal={openEditFolderModal}
        openRemoveConfirmationModal={openRemoveConfirmationModal}
        isListMode={isListMode}
        isOver={isOver}
      />
    </div>
  )
}
